import React, { useEffect } from "react";
import ProSpaceContainerCss from "containers/v2/ProSpaceContainer/ProSpaceContainer.module.css";
import Empty from "./../../../../../assets/img/inbox-empty/empty.png";

import {
  actions as UserSpaceActions,
  selectors as UserSpaceSelectors,
} from "redux/slices/v2/UserSpace";

import {
  actions as ProSpaceActions,
  selectors as ProSpaceSelectors,
} from "redux/slices/v2/ProSpace";

import { useDispatch, useSelector } from "react-redux";

export default function NoDataPlaceHolder({
  children,
  title,
  message,
  from404
}: {
  children?: React.ReactElement | React.ReactElement[];
  title: string | React.ReactElement | React.ReactElement[];
  message?: string | React.ReactElement | React.ReactElement[];
  from404?: boolean
}) {

  useEffect(() => {
    if (title === "Aucun contact" || title === "Aucune annonce disponible") {
      const myContainer = document.getElementById("container");
      myContainer.style.height =
        title === "Aucun contact"
          ? "calc(100dvh - 221px)"
          : "calc(100dvh - 180px)";
    }
  }, []);
  return (
    <div id="container" className={`${ProSpaceContainerCss.pageContainer__no_data} ${from404 ? ProSpaceContainerCss.pageContainer__no_data__404 : ""}`}>
      <div className={ProSpaceContainerCss.pageContentContainer__no_data}>
        <div className={`${ProSpaceContainerCss.NoDataPlaceHolderContainer} ${from404 ? ProSpaceContainerCss.NoDataPlaceHolderContainer404 : ""}`}>
          <img
            src={Empty.src}
            alt=""
            className={ProSpaceContainerCss.InboxEmptyLogo}
          />

          <div className={ProSpaceContainerCss.textsContainer}>
            <p className={ProSpaceContainerCss.NoDataPlaceHolderTitle}>
              {title}
            </p>
            <p className={ProSpaceContainerCss.noContactsMessage}>{message}</p>
            <p className={ProSpaceContainerCss.NoDataPlaceHolderMessage}>
              {children}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
